import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledItemName = styled(Text)`
	font-size: 14px;
	color: #ffffff;
	transition: color 0.3s ease;

	span {
		opacity: 0.5;
	}
`;

const StyledCountContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 15px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;

		span {
			opacity: 0.5;
		}
	}
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	img {
		transition: filter 0.3s ease;
	}
`;

const StyledContainer = styled.div<{ $active?: boolean }>`
	display: grid;
	grid-template-columns: 30px 1fr 1px 120px 1px 112px;
	align-items: center;
	gap: 15px;
	height: 40px;
	min-height: 40px;
	padding: 0 15px 0 5px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: #ffffff;

		${StyledItemName} {
			color: #000000;
		}

		${StyledCountContainer} {
			${Text} {
				color: #000000;
			}

			img {
				filter: invert(1);
			}
		}

		${StyledPriceContainer} {
			${Text} {
				color: #000000;
			}

			img {
				filter: invert(1);
			}
		}

		${Divider} {
			background-color: #000000;
		}
	}
`;

export {
	StyledContainer,
	StyledCountContainer,
	StyledItemName,
	StyledPriceContainer,
};
